import React from "react"
import { Flex, Button, Text } from "@chakra-ui/react"

import { useRoutes } from "@app/hooks/useRoutes"
import Link from "@app/components/Link"
import { useColorPreset } from "@app/hooks/useColorPreset"

type Props = {
  item: GatsbyTypes.SanityLink | null
  handleLinkClick: () => void
  handleActiveLink: (state: any) => void
  activeLink: any
}

const NavigationHeaderMegaLevel2Link: React.FC<Props> = ({ item, activeLink, handleLinkClick, handleActiveLink }) => {
  const { anyUrlResolver } = useRoutes()

  const resolvedLink = anyUrlResolver(item)

  const isActiveLink = activeLink?._key === item?._key

  const badgeText = item?.badgeText
  const { color: badgeTextColor } = useColorPreset(item?.badgeTextColor) || "primay.white"
  const { color: badgeBgColor } = useColorPreset(item?.badgeBgColor) || "grey.lighter"

  const subHeading = item?.subHeading

  return (
    <Flex
      flexDirection="column"
      gap={0}
      onMouseEnter={() => handleActiveLink(item)}
      onMouseLeave={() => handleActiveLink(null)}
      opacity={isActiveLink || !activeLink ? 1 : 0.6}
      transition="all 0.3s ease"
    >
      <Flex flexDirection="row" gap={3} alignItems="center">
        <Button
          variant="headerMegaItemLevel2"
          as={Link}
          to={resolvedLink?.url}
          justifyContent="flex-start"
          onClick={() => {
            handleLinkClick?.()
          }}
        >
          {item?.title}
        </Button>
        {badgeText ? (
          <Text as="span" size="sm" variant="medium" color={badgeTextColor} bgColor={badgeBgColor} px={1.5} borderRadius="16px">
            {badgeText}
          </Text>
        ) : null}
      </Flex>

      {subHeading ? (
        <Text as="span" size="md" color="primary.midGrey" mt={-2}>
          {subHeading}
        </Text>
      ) : null}
    </Flex>
  )
}

export default React.memo(NavigationHeaderMegaLevel2Link)
